<div class="input-field" [formGroup]="parentFormGroup">
	<mat-radio-group [formControlName]="nazevPrvkuFormulare" [required]="jeHodnotaPovinna()">
		<mat-radio-button *ngFor="let p of polozky | klice" [disabled]="neaktivniPolozky.includes(p.value)" class="example-radio-button" [value]="p.key">
			{{ p.value | typEnumu: polozky }}
		</mat-radio-button>
	</mat-radio-group>
	<mat-hint *ngIf="!pripravitErrorZpravu()">{{ napoveda | lokalizace }}</mat-hint>
	<mat-error>{{ pripravitErrorZpravu() }}</mat-error>
</div>
